import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {Col, Row} from 'react-bootstrap';
import _ from 'lodash';
import EditLargeCard from '../main/edit-large-card';
import LeftSide from '../main/left-side';
import TitleCard from '../main/title-card';
import LocationBasicForm, {
    FIELD_BOOKING_LOGIC,
    FIELD_BOOKING_MINUTES,
    FIELD_GATEWAY_SERIALNUMBER,
} from './forms/location-basic-form';
import LocationPositionForm from './forms/location-position-form';
import translate from '../translate';
import {
    LoadLocation,
    LoadLocationsForMansionId,
    RemoveLocation,
    resetRemoveLocation,
    UpdateLocation,
} from '../../store/locationsSlice';
import {REQUEST_FAILURE} from '../../store/network/managedRequest';
import {LoadMansions} from '../../store/mansionsSlice';
import LocationNoteForm from './forms/location-note-form';
import LocationPricingCard from './prices/location-pricing-card';
import {goToMansion} from '../../nav/navigationService';
import createReactClass from 'create-react-class';
import ShowOnDisabled from '../main/show-on-disabled';
import ConfirmButton from '../util/confirm-button';
import memoize from 'memoize-one';
import {usingFeatureWriteAccess} from '../../util/usingFeatureAccess';
import {PbRequest} from '../../store/pbRequest';
import withParams from '../../nav/withParams';

const defaultFields = {
    name: '',
    gps_lat: 0,
    gps_lon: 0,
    mansion_id: '',
    num_of_appartments: '',
    washer_cost: '',
    dryer_cost: '',
    reservation_minutes: 10,
    [FIELD_BOOKING_MINUTES]: 10,
    pickup_minutes: 10,
    note: '',
    currency_type: 'EUR',
};
const EditLocation = createReactClass({
    propTypes: {
        strings: PropTypes.object,
        params: PropTypes.shape({
            location_id: PropTypes.string,
            object_id: PropTypes.string,
        }).isRequired,
        LoadLocation: PropTypes.func.isRequired,
        RemoveLocation: PropTypes.func.isRequired,
        LoadLocationsForMansionId: PropTypes.func.isRequired,
        UpdateLocation: PropTypes.func.isRequired,
        locationsByMansionsById: PropTypes.shape({}).isRequired,
        updateLocationCall: PropTypes.shape({
            status: PropTypes.string,
            errors: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
        LoadMansions: PropTypes.func.isRequired,
        removeLocationErrors: PropTypes.arrayOf(PropTypes.string),
        resetRemoveLocation: PropTypes.func.isRequired,
        selectedPartner: PropTypes.shape({}),
    },

    componentDidMount() {
        this.props.LoadMansions();
        this.props.LoadLocation(Number(this.props.params.location_id));
        this.props.LoadLocationsForMansionId(
            Number(this.props.params.object_id)
        );
        this.props.resetRemoveLocation();
    },

    getLocationFromStores() {
        const mansionId = Number(this.props.params.object_id);
        const locationId = Number(this.props.params.location_id);
        if (
            mansionId &&
            locationId &&
            this.props.locationsByMansionsById[mansionId] &&
            this.props.locationsByMansionsById[mansionId][locationId]
        ) {
            return this.props.locationsByMansionsById[mansionId][locationId];
        }
        return null;
    },
    _hasWriteAccess: memoize((selectedPartner) =>
        usingFeatureWriteAccess(selectedPartner, 'RESIDENTIAL_LOCATION')
    ),
    _removeLocation() {
        this.props.RemoveLocation(this.props.params.location_id, () =>
            goToMansion(this.props.params.object_id)
        );
    },
    getDeleteErrorMessage() {
        let errorMessage = null;
        const errors = this.props.removeLocationErrors;

        if (errors && errors.length > 0) {
            let errorString;
            if (errors[0] === 'APPLIANCE_EXIST') {
                errorString = this.props.strings.applianceExistError;
            } else {
                errorString = this.props.strings.generalError;
            }

            errorMessage = <div className="alert-danger">{errorString}</div>;
        }
        return errorMessage;
    },

    _getUpdateErrorMessage() {
        const errors = this.props.updateLocationCall.errors;
        if (this.props.updateLocationCall.status === REQUEST_FAILURE) {
            const knownErrors = _.map(errors, (it) =>
                this.props.strings.errorTags[it] ? (
                    <div key={it} className="alert alert-danger">
                        {this.props.strings.errorTags[it]}
                    </div>
                ) : null
            );
            return [
                <div key="UNKNOWN" className="alert alert-danger">
                    {this.props.strings.errorTags.UNKNOWN}
                </div>,
                ...knownErrors,
            ];
        }
        return null;
    },

    getCards(info, location) {
        const hasLocationError =
            this.props.updateLocationCall.status === REQUEST_FAILURE;
        const noteValues = { note: location.note };
        const hasWriteAccess = this._hasWriteAccess(this.props.selectedPartner);

        const locationInfoCard = (
            <EditLargeCard
                title={`${this.props.strings.create1} ${this.props.strings.create2}`}
                handleSubmit={this._handleLocationForm}
                validationEnabled
                submitLabel={this.props.strings.saveSection}
                handleCancel={() => this._handleCancelEditBasicForm()}
                error={hasLocationError}
                errorElement={this._getUpdateErrorMessage()}
                disabled={!hasWriteAccess}
            >
                <LocationBasicForm
                    info={info}
                    forceValidation
                    mansionId={parseInt(this.props.params.object_id, 10)}
                />
                {hasWriteAccess && (
                    <ShowOnDisabled>
                        {this.getDeleteErrorMessage()}
                        <ConfirmButton
                            danger
                            onConfirmedAction={() => this._removeLocation()}
                            linkClassName="icon icon-wew-trash icon-sm"
                            confirmTitle={this.props.strings.deleteModal.title}
                            confirmMessage={
                                this.props.strings.deleteModal.description
                            }
                            confirmAction={
                                this.props.strings.deleteModal.confirm
                            }
                            rejectAction={this.props.strings.deleteModal.cancel}
                        >
                            <span
                                className="btn btn-action"
                                style={{
                                    marginLeft: '1em',
                                }}
                            >
                                {this.props.strings.delete}
                            </span>
                        </ConfirmButton>
                    </ShowOnDisabled>
                )}
            </EditLargeCard>
        );
        const locationNoteCard = (
            <EditLargeCard
                title={this.props.strings.note}
                handleSubmit={this._handleLocationNoteForm}
                validationEnabled
                submitLabel={this.props.strings.saveSection}
                disabled={!hasWriteAccess}
            >
                <LocationNoteForm values={noteValues} forceValidation />
            </EditLargeCard>
        );
        return { locationInfoCard, locationNoteCard };
    },

    getCombinedLocation() {
        return { ...this.getLocationFromStores() };
    },

    _handleLocationForm(info) {
        const location = _.extend(this.getCombinedLocation(), {
            name: info.name,
            num_of_appartments: info.num_of_appartments,
            reservation_minutes: info.reservation_minutes,
            pickup_minutes: info.pickup_minutes,
            [FIELD_BOOKING_MINUTES]: info[FIELD_BOOKING_MINUTES],
            [FIELD_BOOKING_LOGIC]: info[FIELD_BOOKING_LOGIC],
            [FIELD_GATEWAY_SERIALNUMBER]: info[FIELD_GATEWAY_SERIALNUMBER],
        });
        if (info._valid) {
            this.props.UpdateLocation(location);
        }
    },

    _handleLocationNoteForm(values) {
        const noteData = {
            note: values.note,
        };
        const location = _.extend(this.getCombinedLocation(), noteData);
        if (values._valid) {
            this.props.UpdateLocation(location);
        }
    },

    _handleLocationPositionForm(data) {
        const positionData = {
            gps_lat: data.position.lat,
            gps_lon: data.position.lon,
        };
        const location = _.extend(this.getCombinedLocation(), positionData);
        if (data._valid) {
            this.props.UpdateLocation(location);
        }
    },

    _handleCancelEditBasicForm() {
        this.props.LoadLocation(Number(this.props.params.location_id));
        this.props.LoadLocationsForMansionId(
            Number(this.props.params.object_id)
        );
    },

    _handleCancelLocationChange() {
        const location = this.getCombinedLocation();
        this.locationForm.setMapPosition({
            lat: location.gps_lat,
            lon: location.gps_lon,
        });
    },

    getLocationCard() {
        const hasLocationError =
            this.props.updateLocationCall.status === REQUEST_FAILURE;
        const location = this.getCombinedLocation();
        const coords = { lat: location.gps_lat, lon: location.gps_lon };
        const hasWriteAccess = this._hasWriteAccess(this.props.selectedPartner);
        return (
            <EditLargeCard
                title={this.props.strings.location}
                handleSubmit={this._handleLocationPositionForm}
                handleCancel={this._handleCancelLocationChange}
                submitLabel={this.props.strings.saveSection}
                disabled={!hasWriteAccess}
                error={hasLocationError}
            >
                <LocationPositionForm
                    position={coords}
                    refCallback={(ref) => (this.locationForm = ref)}
                />
            </EditLargeCard>
        );
    },

    render() {
        const location = this.getCombinedLocation();
        if (location) {
            const info = {
                id: location.id,
                name: location.name,
                [FIELD_BOOKING_LOGIC]: location[FIELD_BOOKING_LOGIC],
                [FIELD_BOOKING_MINUTES]: location[FIELD_BOOKING_MINUTES],
                num_of_appartments: location.num_of_appartments,
                reservation_minutes: location.reservation_minutes,
                pickup_minutes: location.pickup_minutes,
                [FIELD_GATEWAY_SERIALNUMBER]:
                    location[FIELD_GATEWAY_SERIALNUMBER],
            };
            const { locationInfoCard, locationNoteCard } = this.getCards(
                info,
                location
            );
            const hasWriteAccess = this._hasWriteAccess(
                this.props.selectedPartner
            );
            return (
                <Row>
                    <LeftSide>
                        <TitleCard
                            title={[
                                this.props.strings.create1,
                                this.props.strings.create2,
                            ]}
                            left={{
                                content: (
                                    <Link
                                        to={`/objects/${location.mansion_id}/${location.id}`}
                                        className="icon icon-wew-arrow-left icon-sm"
                                    />
                                ),
                                title: this.props.strings.cancel,
                            }}
                        />
                    </LeftSide>
                    <Col xs={6} sm={6} md={6} lg={6} className="col-middle">
                        <Row>
                            {locationInfoCard}
                            {hasWriteAccess && this.getLocationCard()}
                            <LocationPricingCard
                                locationId={location.id}
                                hideLinkToDiscount
                                disabled={!hasWriteAccess}
                            />
                            {locationNoteCard}
                        </Row>
                    </Col>
                </Row>
            );
        } else {
            return <div />;
        }
    },
});

export default connect(
    (store) => ({
        locationsByMansionsById: store.locations.locationsByMansionsById,
        removeLocationErrors: store.pbRequest[PbRequest.REMOVE_LOCATION].errors,
        updateLocationCall: store.pbRequest[PbRequest.UPDATE_LOCATION],
        selectedPartner: store.partnerManager.selectedPartner,
    }),
    {
        RemoveLocation,
        LoadLocationsForMansionId,
        LoadLocation,
        UpdateLocation,
        LoadMansions,
        resetRemoveLocation,
    }
)(translate('EditLocation')(withParams(EditLocation)));
